export default __webpack_public_path__ + "static/media/refer-a-friend-mobile.7acad2ee.png";